module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  1. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Champagne Wishes and Clam-Free Dreams")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  2. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("Room to Romp")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  3. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3"
    }
  }, [_vm._v("The Day My Tipsy Dad Went Punk and Hit My Mom (Or, My Year in TV Movies)")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  4. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coming of Stage")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  5. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Being Clarissa")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  6. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is That Teen Spirit I Smell?")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  7. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Straight from the Hart")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  8. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moms Do the Darndest Things")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  9. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An A for Effort")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("10. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abracadabra! Another Hit!")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("11. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just Say “Why Not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("12. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The One That Never Got Away")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("13. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Traveling Family Circus")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("14. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s All About the Canapés, Baby")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("15. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Are You Ready for Some Football?")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("16. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four Things I Never Learned to Do for Myself")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("17. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Mommy’s Worlds Collide")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("18. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abnormally Normal")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo1#pho",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0